import { useEffect, useRef } from 'react';

/**
 * useLatest
 * Keeps a ref always pointing to the latest value.
 * Useful to avoid stale closures.
 */
export function useLatest<T>(value: T) {
	const ref = useRef(value);

	useEffect(() => {
		ref.current = value;
	}, [value]);

	return ref;
}
